import { putRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const updateHardware = async (payload, id) => {
  try {
    return await putRequest(urls.EDIT_HARDWARE_REQUEST + `/${id}`, payload);
  } catch (err) {
    return err;
  }
};
